module.exports = __webpack_public_path__ + "static/media/google.b60678d5.svg";